export const actions = {
  REORDER_ROOT_OBJECTIVES_REQUEST: 'REORDER_ROOT_OBJECTIVES_REQUEST',
  REORDER_OBJECTIVES: 'REORDER_OBJECTIVES',
  ADD_TO_OBJECTIVE_TREE_REQUEST: 'ADD_TO_OBJECTIVE_TREE_REQUEST',
  SET_FLAT_OBJECTIVES: 'SET_FLAT_OBJECTIVES',
  REORDER_UNDER_SAME_PARENT_REQUEST: 'REORDER_UNDER_SAME_PARENT_REQUEST',
  REORDER_OBJECTIVES_UNDER_SAME_PARENT: 'REORDER_OBJECTIVES_UNDER_SAME_PARENT',
  REORDER_UNDER_DIFF_PARENT_REQUEST: 'REORDER_UNDER_DIFF_PARENT_REQUEST',
  REORDER_OBJECTIVES_UNDER_DIFF_PARENT: 'REORDER_OBJECTIVES_UNDER_DIFF_PARENT',
  REVERT_OBJECTIVE_MOVE_ACTION: 'REVERT_OBJECTIVE_MOVE_ACTION',
  REVERT_OBJECTIVE_MOVE_ACTION_REQUEST: 'REVERT_OBJECTIVE_MOVE_ACTION_REQUEST',
  SHOW_OKR_HIERACHY_TOAST: 'SHOW_OKR_HIERACHY_TOAST',
  APPROVE_ALL_MANAGER_OBJECTIVES: 'APPROVE_ALL_MANAGER_OBJECTIVES'
};

export const reorderRootObjectivesRequest = (
  objective_id,
  newIndex,
  oldIndex,
  isUndoAction = false
) => ({
  type: actions.REORDER_ROOT_OBJECTIVES_REQUEST,
  objective_id,
  newIndex,
  oldIndex,
  isUndoAction
});

export const reorderObjectives = (objective_id, newIndex, oldIndex) => ({
  type: actions.REORDER_OBJECTIVES,
  objective_id,
  newIndex,
  oldIndex
});

export const addToObjectiveTreeRequest = (
  dragged_objective_id,
  new_parent_objective_id,
  parentObjectiveId,
  draggingLinkedObjective,
  sourceIndex
) => ({
  type: actions.ADD_TO_OBJECTIVE_TREE_REQUEST,
  dragged_objective_id,
  new_parent_objective_id,
  parentObjectiveId,
  draggingLinkedObjective,
  sourceIndex
});

export const setFlatObjectives = flatObjectives => ({
  type: actions.SET_FLAT_OBJECTIVES,
  flatObjectives
});

export const reorderUnderSameParentRequest = (
  objective_id,
  parent_objective_id,
  destinationIndex,
  sourceIndex,
  positionIndex,
  isUndoAction = false
) => ({
  type: actions.REORDER_UNDER_SAME_PARENT_REQUEST,
  objective_id,
  parent_objective_id,
  destinationIndex,
  sourceIndex,
  positionIndex,
  isUndoAction
});

export const reorderObjectivesUnderSameParent = (
  objective_id,
  parent_objective_id,
  destinationIndex,
  sourceIndex,
  positionIndex
) => ({
  type: actions.REORDER_OBJECTIVES_UNDER_SAME_PARENT,
  objective_id,
  parent_objective_id,
  destinationIndex,
  sourceIndex,
  positionIndex
});

export const reorderUnderDiffParentRequest = (
  objective_id,
  parent_objective_id,
  destinationIndex,
  sourceIndex,
  positionIndex,
  draggingLinkedObjective
) => ({
  type: actions.REORDER_UNDER_DIFF_PARENT_REQUEST,
  objective_id,
  parent_objective_id,
  destinationIndex,
  sourceIndex,
  positionIndex,
  draggingLinkedObjective
});

export const reorderObjectivesUnderDiffParent = (
  objective,
  objective_id,
  parent_objective_id,
  destinationIndex,
  sourceIndex,
  positionIndex
) => ({
  type: actions.REORDER_OBJECTIVES_UNDER_DIFF_PARENT,
  objective,
  objective_id,
  parent_objective_id,
  destinationIndex,
  sourceIndex,
  positionIndex
});

export const revertObjectiveMoveAction = undoActionData => ({
  type: actions.REVERT_OBJECTIVE_MOVE_ACTION,
  undoActionData
});

export const revertObjectiveMoveActionRequest = undoActionData => ({
  type: actions.REVERT_OBJECTIVE_MOVE_ACTION_REQUEST,
  undoActionData
});

export const showOKRHierarchyToast = () => ({
  type: actions.SHOW_OKR_HIERACHY_TOAST
});

export const approveAllManagerObjectives = data => ({
  type: actions.APPROVE_ALL_MANAGER_OBJECTIVES,
  data
});
